var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSilverStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "METAL-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 7.16 7.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Pearl);}.cls-2{opacity:0.7;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Pearl",
    cx: 3.58,
    cy: 3.58,
    r: 3.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fffdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f3f3ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d7dade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#dcd9d4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cost_Panel_v1",
    "data-name": "Cost Panel_v1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PL_3",
    "data-name": "PL 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3.58,
    cy: 3.58,
    r: 3.58
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.58 1.34 4.31 2.81 5.93 3.05 4.76 4.2 5.04 5.82 3.58 5.05 2.12 5.82 2.4 4.2 1.22 3.05 2.85 2.81 3.58 1.34"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverStar);
export default __webpack_public_path__ + "static/media/silverStar.e0de090bf20b02950ff7599052382f61.svg";
export { ForwardRef as ReactComponent };